<template>
  <div class="software-icon flex-column" :class='color ? "color" : undefined'>
    <img class="image" :alt="name" :src="`/icons/${name}.png`">
    <span class="flex-row title">{{$t(name)}}</span>
  </div>
</template>

<script>
export default {
  name: 'SoftwareIcon',
  components: {
  },
  props: {
    name: String,
    color: Boolean,
  },
}
</script>

<style lang="scss" scoped>
.software-icon {

  .image {
    object-fit: contain;
    max-height: 64px;
    filter: grayscale(1);
  }

  .title {
    margin-top: 15px;
    justify-content: center;
  }
}

.software-icon.color {
  .image {
    filter: grayscale(0);
  }
}

</style>
